export default "__VITE_ASSET__huFucekz__"